import React from 'react';

export default function InstructionCard({ onDone }) {
    return (
        <div className="oc-instruction-card">
            <h4 className="oc-instruction-title">Enable Community AI on Circle</h4>
            <ol className="oc-instruction-list">
                <li>
                    Click your community name or logo, or the dropdown icon next to it,
                    on the top navigation bar, and select <strong>Settings</strong>.
                </li>
                <li>
                    From the sidebar menu, go to <strong>Community AI</strong>.
                </li>
                <li>
                    Toggle the specific feature on or off. When enabled, you can adjust
                    its additional settings based on your preference.
                </li>
                <li>
                    Click <strong>Save</strong> to confirm your changes.
                </li>
            </ol>
            <button className="oc-btn oc-btn-primary" onClick={onDone}>
                Done, I've enabled it!
            </button>
        </div>
    );
}
